import { KeyValuePipe } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

import { DemoTextFields } from '@demo/data/demo-cipo-fields';
import { CipoTextComponent } from '@shared/components/fields/cipo-text/cipo-text.component';
import { CipoTextControl } from '@shared/components/fields/common';

@Component({
  selector: 'app-demo-cipo-text',
  imports: [CipoTextComponent, KeyValuePipe, FlexLayoutModule],
  templateUrl: './demo-cipo-text.component.html',
})
export class DemoCipoTextComponent {
  dialog = inject(MatDialog);

  form = signal(new FormGroup<{ [x: string]: CipoTextControl }>({}));

  constructor() {
    DemoTextFields.forEach(field => {
      const { name, defaultValue, ...props } = field;
      const control = new CipoTextControl(defaultValue, props);
      this.form().addControl(name, control);
    });
  }
}
